module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABHNCSVQICAgIfAhkiAAAAVVJREFUSIm1llGugyAQRQ+mWyDtboors67s0d1oXITvg1ERERHt/TExeA8Z7owoMjS8MIw03isjTwuA4qs7PjleKhNkUus82SN4FFgACl3bPegGKLC/ItDWvdadlD0GvBW2A10Dn4y3wkS6XzjVDHvlpaxEw3OpWjXD1rG/W2Z4uQAq2cFPShnI6p5a3R4URQsQrZiiflDaa3FYrTusf2ahKkbeN6BsADPRVSPN4zLKmypJ2LT8IDA2aXASBl4f7hmiqGE9nlhKeAo2AUMzX0Z3Ls5z+iTe07g6AwNX0vQHicl/FgbYdEkBRprY2CuAgeJbeaXKhhbBnOw02vIMFK30bQkM3aOq2ShHF28B7iG6UKYs2BS8BfiLv70o+gPWnWvm22mB56otBJp3npmw8BK16UPd8dkZZ2dkYzC3h4QKrh5WArIBZQE9sAFMpAetuLQgR3Kgf8JokD1rCamAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teacher-task/select.png
// module id = HL4v
// module chunks = 1